import { useMemo } from "react"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import SearchFormContainer from "Components/atoms/containers/search-form-container"
import TextInput from "Components/molecule/inputs/text-input"
import MultiSelect from "Components/molecule/inputs/multi-select"
import { IClientQueryParams } from "models/client"
import useEnterSearch from "hooks/useEnterSearch"

interface SearchClientFormProps {
    query: IClientQueryParams
    isSearching: boolean
    handleChangeQuery: (key: string, value: any) => void
    handleSearch: () => void
    handleClearSearch: () => void
}

const SearchClientForm = ({
    query,
    isSearching,
    handleChangeQuery,
    handleSearch,
    handleClearSearch,
}: SearchClientFormProps) => {
    const { inputProps } = useEnterSearch(handleSearch)
    return (
        <SearchFormContainer
            inputs={<>
                <TextInput
                    label="Name"
                    placeholder="Search by name"
                    value={query.name ?? ""}
                    onChange={(e) => handleChangeQuery('name', e.target.value)}
                    {...inputProps}
                />
            </>}
            clearSearchButton={
                <>
                    <PrimaryButton
                        style={{ minWidth: '150px' }}
                        disabled={isSearching}
                        onClick={handleSearch}
                    >
                        {isSearching ? 'Searching...' : 'Search'}
                    </PrimaryButton>
                    <SecondaryButton
                        style={{ minWidth: '100px' }}
                        disabled={isSearching}
                        onClick={handleClearSearch}
                    >
                        Clear Search
                    </SecondaryButton>
                </>
            }
        />
    )
}

export default SearchClientForm
